module.exports = __webpack_public_path__ + "static/img/postcode-close.3ff47ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sub/postcode-close.jpg
// module id = 6Zic
// module chunks = 1